export const environment = {
    production: true,
    apiUrl: 'https://api-oberon.buziflow.com',
    firebaseConfig: {
      apiKey: "AIzaSyDX7QJwV6lJTaeYHCj5qt2tI30g5coZSDc",
      authDomain: "buziflowpnmsg.firebaseapp.com",
      projectId: "buziflowpnmsg",
      storageBucket: "buziflowpnmsg.appspot.com",
      messagingSenderId: "131314207038",
      appId: "1:131314207038:web:eb23d8deb7b337b0fd046f",
      measurementId: "G-CH212X4M93"
    },
    version: '4.00.0.0-S',
    excludedNames: [
      'Test GM Jordan Lane',
      'AM Boss',
      'GM Boss',
      'ed bryan',
      'Test GM Washington Street',
      'Test Parts3'
    ]
  };